<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <p>确定删除服务管理</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteHousekeepingServModel">点错了</el-button>
      <el-button type="primary" @click="deleteHousekeepingServ">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteHousekeepingServ } from '@/api/housekeeping/housekeepingServApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteHousekeepingServ',
  data() {
    return {
      dialogVisible: false,
      deleteHousekeepingServInfo: {}
    }
  },
  methods: {
    open(params) {
      this.deleteHousekeepingServInfo = params
      this.dialogVisible = true
    },
    handleClose(done) {
      this.closeDeleteHousekeepingServModel()
      done()
    },
    async deleteHousekeepingServ() {
      try {
        this.deleteHousekeepingServInfo.shopId = getShopId()
        await deleteHousekeepingServ(this.deleteHousekeepingServInfo)
        this.$emit('refresh')
        this.$message.success('删除成功')
        this.dialogVisible = false
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(error || '删除失败')
      }
    },
    closeDeleteHousekeepingServModel() {
      this.dialogVisible = false
    }
  }
}
</script>